/* DSL Find similar — gebruikt /recommendations/products endpoint */
(function(){
  document.addEventListener("click", function(e){
    var b = e.target.closest("[data-find-similar]"); if (!b) return;
    e.preventDefault();
    var pid = b.dataset.findSimilar;
    fetch("/recommendations/products?product_id=" + pid + "&limit=8&intent=related").then(function(r){return r.text();}).then(function(html){
      var slot = document.querySelector("[data-find-similar-results]");
      if (slot) slot.innerHTML = html;
      if (window.DSL_AB) window.DSL_AB.track("find_similar", {pid: pid});
    });
  });
})();